"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.regexp.to-string");

var _axios = _interopRequireDefault(require("axios"));

var _bitcoinjsMessage = require("bitcoinjs-message");

var _bitcoinjsLib = require("bitcoinjs-lib");

var _config = require("../../config");

var _FLOTransactionBuilder = _interopRequireDefault(require("../flo/FLOTransactionBuilder"));

var _FLOTransaction = require("../flo/FLOTransaction");

var _Peer = _interopRequireDefault(require("../flo/Peer"));

var _util = require("../../util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Helper const


var ONE_MB = 1000000;
var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND; // 1 satoshis per byte (1000 satoshi per kb) (100 million satoshi in 1 FLO)

var TX_FEE_PER_BYTE = 0.00000001; // Average size of tx data (without floData) to calculate min txFee

var TX_AVG_BYTE_SIZE = 200;
var SAT_PER_FLO = 100000000; // The minimum amount a utxo is allowed to be for us to use

var MIN_UTXO_AMOUNT = 0.0001; // Prevent chaining over ancestor limit

var MAX_MEMPOOL_ANCESTORS = 1250;
var MAX_MEMPOOL_ANCESTOR_SIZE = 1.75 * ONE_MB; // Timer lengths used to track and fix the Ancestor chain

var UPDATE_ANCESTOR_STATUS = 1 * ONE_SECOND;
var REPAIR_ANCESTORS_AFTER = 1 * ONE_MINUTE;
var PEER_CONNECT_LENGTH = 2 * ONE_SECOND;
var REBROADCAST_LENGTH = 10 * ONE_SECOND;
var REPAIR_MIN_TX = 100; // List of all Wallet-Only RPC Methods

var WALLET_RPC_METHODS = ['selectwallet', 'getwalletinfo', 'fundrawtransaction', 'resendwallettransactions', 'abandontransaction', 'addmultisigaddress', 'addwitnessaddress', 'backupwallet', 'dumpprivkey', 'dumpwallet', 'encryptwallet', 'getaccountaddress', 'getaccount', 'getaddressesbyaccount', 'getbalance', 'getnewaddress', 'getrawchangeaddress', 'getreceivedbyaccount', 'getreceivedbyaddress', 'gettransaction', 'getunconfirmedbalance', 'importprivkey', 'importwallet', 'importaddress', 'importprunedfunds', 'importpubkey', 'keypoolrefill', 'listaccounts', 'listaddressgroupings', 'lockunspent', 'listlockunspent', 'listreceivedbyaccount', 'listreceivedbyaddress', 'listsinceblock', 'listtransactions', 'listunspent', 'move', 'sendfrom', 'sendmany', 'sendtoaddress', 'setaccount', 'settxfee', 'signmessage', 'walletlock', 'walletpassphrasechange', 'walletpassphrase', 'removeprunedfunds'];
/**
 * Easily interact with an RPC Wallet to send Bulk transactions extremely quickly in series
 */

var RPCWallet = /*#__PURE__*/function () {
  function RPCWallet(options) {
    _classCallCheck(this, RPCWallet);

    // Store options for later
    this.options = options || {}; // Set default network to livenet if unset

    if (!this.options.network) {
      this.options.network = 'livenet';
    } // Make sure we have connection to an RPC wallet


    if (!this.options.rpc) {
      throw new Error("RPC options ('options.rpc') are required with an RPC wallet!");
    } // Make sure we are being passed a public and private key pair


    if (!this.options.wif) {
      throw new Error('`wif` (a Private Key) is a required option in order to use RPC Wallet!');
    }

    if (!this.options.publicAddress) {
      throw new Error('`publicAddress` (the Public Address for the `wif`) is a required option in order to use RPC Wallet!');
    } // If the port is not set, default to Livenet (7313), otherwise if they passed the string "testnet" use the testnet port (17313)


    if (!this.options.rpc.port) {
      if (this.options.network && this.options.network === 'testnet') {
        this.options.rpc.port = 17313;
      } else if (this.options.network && this.options.network === 'regtest') {
        this.options.rpc.port = 17413;
      } else {
        this.options.rpc.port = 7313;
      }
    } // If host is not set, use localhost


    if (!this.options.rpc.host) {
      this.options.rpc.host = 'localhost';
    } // Create the RPC connection using Axios


    this.rpc = _axios.default.create({
      auth: {
        username: this.options.rpc.username,
        password: this.options.rpc.password
      },
      validateStatus: function validateStatus(status) {
        if ([400, 401, 402, 403, 404].includes(status)) {
          return false;
        }

        return true;
      }
    }); // Default to not being an fcoin RPC node

    this.fcoinRPC = false; // Store the Private Key and the Public Key

    this.wif = this.options.wif;
    this.publicAddress = this.options.publicAddress;
    this.importPrivateKey = this.options.importPrivateKey || true; // Store the "coin" network we should use

    if (this.options.network === 'livenet' || this.options.network === 'mainnet' || this.options.network === 'main') {
      this.coin = _config.floMainnet;
    } else if (this.options.network === 'testnet') {
      this.coin = _config.floTestnet;
    } else if (this.options.network === 'regtest') {
      this.coin = _config.floRegtest;
    } // Store information about our tx chain and the previous tx output


    this.unconfirmedTransactions = [];
    this.previousTXOutput = undefined; // Initialize our initial peer array

    this.peers = []; // Variables to count utxo ancestors (maximum number of unconfirmed transactions you can chain)

    this.currentAncestorCount = 0;
    this.currentAncestorSize = 0; // Repair mode tracker

    this.repairMode = false;
  }
  /**
   * Make any RPC request
   * @param  {String} method - The RPC method you wish to call
   * @param  {Array} parameters - The parameters to pass to with RPC method you are calling
   * @return {Object} Returns the data response
   */


  _createClass(RPCWallet, [{
    key: "rpcRequest",
    value: function () {
      var _rpcRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(method, parameters) {
        var rpcRequest, rpcPort;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (method) {
                  _context.next = 2;
                  break;
                }

                throw new Error("rpcRequest parameter 'method' is Required!");

              case 2:
                if (parameters) {
                  _context.next = 4;
                  break;
                }

                throw new Error("rpcRequest parameter 'parameters' is Required!");

              case 4:
                _context.prev = 4;
                // Make sure that rpcPort is an int so that we don't append 2 as a string to the port
                rpcPort = parseInt(this.options.rpc.port); // If we are using an fcoin RPC, the wallet RPC runs on a different port (7315/17315 instead of 7313/17313)

                if (WALLET_RPC_METHODS.includes(method) && this.fcoinRPC) {
                  rpcPort += 2;
                } // Attempt the RPC request


                _context.next = 9;
                return this.rpc.post("http://".concat(this.options.rpc.host, ":").concat(rpcPort, "/"), {
                  'jsonrpc': '2.0',
                  'id': 1,
                  'method': method,
                  'params': parameters
                });

              case 9:
                rpcRequest = _context.sent;

                if (!(rpcRequest.data && rpcRequest.data.error && rpcRequest.data.error.message && rpcRequest.data.error.message.includes('Method not found'))) {
                  _context.next = 13;
                  break;
                }

                this.fcoinRPC = true;
                return _context.abrupt("return", this.rpcRequest(method, parameters));

              case 13:
                _context.next = 21;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](4);
                // Throw if there was some weird error for some reason.
                console.log("[RPC Wallet] Unable to perform RPC request, retrying! Method: '" + method + "' - Params: '" + JSON.stringify(parameters) + "' | RPC settings: " + JSON.stringify(this.options.rpc) + ' | Thrown Error: ' + _context.t0); // Sleep 1 second

                _context.next = 20;
                return new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    resolve();
                  }, 1000);
                });

              case 20:
                return _context.abrupt("return", this.rpcRequest(method, parameters));

              case 21:
                return _context.abrupt("return", {
                  result: rpcRequest.data.result,
                  error: rpcRequest.data.error
                });

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 15]]);
      }));

      function rpcRequest(_x, _x2) {
        return _rpcRequest.apply(this, arguments);
      }

      return rpcRequest;
    }()
    /**
     * Grab the latest unconfirmed tx and check how many ancestors it has
     * @return {Boolean} Returns true if the update was successful
     */

  }, {
    key: "updateAncestorStatus",
    value: function () {
      var _updateAncestorStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var utxos, mostRecentUTXO, mostRecentTXID, getMempoolEntry, checkConfirmations, txMempoolStatus;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('[RPC Wallet] Updating Ancestor Status...'); // We next check to see if there are any transactions currently in the mempool that we need to be aware of.
                // To check the mempool, we start by grabbing the UTXO's to get the txid of the most recent transaction that was sent

                _context2.next = 3;
                return this.getUTXOs();

              case 3:
                utxos = _context2.sent;
                // Grab the most recent txid
                mostRecentUTXO = utxos[0];
                mostRecentTXID = mostRecentUTXO.txid; // Check to see if the utxo is still in the mempool and if it has ancestors

                _context2.next = 8;
                return this.rpcRequest('getmempoolentry', [mostRecentTXID]);

              case 8:
                getMempoolEntry = _context2.sent;

                if (!(getMempoolEntry.error && getMempoolEntry.error !== null)) {
                  _context2.next = 27;
                  break;
                }

                if (!(getMempoolEntry.error.message === 'Transaction not in mempool' || getMempoolEntry.error.message === 'Transaction not in mempool.')) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 13;
                return this.rpcRequest('getrawtransaction', [mostRecentTXID, true]);

              case 13:
                checkConfirmations = _context2.sent;

                // Ignore if there was an error, but set the number of confirmations if available
                if (checkConfirmations.result && checkConfirmations.result.confirmations) {
                  mostRecentUTXO.confirmations = checkConfirmations.result.confirmations;
                } // Check to make sure if it is not in the mempool, that it at least has one confirmation.


                if (!(mostRecentUTXO.confirmations >= 1)) {
                  _context2.next = 20;
                  break;
                }

                // Reset utxo count if the most recent one was confirmed
                this.currentAncestorCount = 0;
                this.currentAncestorSize = 0;
                _context2.next = 24;
                break;

              case 20:
                // If we have gotten here, that means the transaction has zero confirmations, and is not included in the mempool, and so we need to repair it's chain...
                console.log('[RPC Wallet] [WARNING] The most recent unspent transaction has zero confirmations and is not in the mempool! Attempting to repair mempool by rebroadcasting transactions, please wait... (txid: ' + mostRecentTXID + ')');
                _context2.next = 23;
                return this.rebroadcastTransactions();

              case 23:
                return _context2.abrupt("return");

              case 24:
                _context2.next = 27;
                break;

              case 26:
                throw new Error('Error grabbing the mempool entry! ' + JSON.stringify(getMempoolEntry.error));

              case 27:
                // If the tx is still in the mempool, it will have results
                if (getMempoolEntry.result) {
                  txMempoolStatus = getMempoolEntry.result; // Store the current ancestor count & size

                  this.currentAncestorCount = txMempoolStatus.ancestorcount;
                  this.currentAncestorSize = txMempoolStatus.ancestorsize; // Also increase the count by one in order to account for the txid from the mempool

                  this.currentAncestorCount++;
                }

                return _context2.abrupt("return", true);

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateAncestorStatus() {
        return _updateAncestorStatus.apply(this, arguments);
      }

      return updateAncestorStatus;
    }()
    /**
     * Add a transaction we just sent to the ancestor count/size
     * @param {String} hex - The transaction hex to count
     * @return {Boolean} Returns true on success
     */

  }, {
    key: "addAncestor",
    value: function addAncestor(hex) {
      // Increase the ancestor count
      this.currentAncestorCount++; // Increase the ancestor size (byte length)

      this.currentAncestorSize += Buffer.from(hex, 'hex').length; // Log every 50

      if (this.currentAncestorCount % 50 === 0) {
        console.log("[RPC Wallet] Updated Ancestor Count: ".concat(this.currentAncestorCount, " - Updated Ancestor Size: ").concat((this.currentAncestorSize / ONE_MB).toFixed(2), "MB"));
      }

      return true;
    }
    /**
     * Checks the current ancestor count and returns when it is safe to send more transactions.
     * This method will wait for tx's in the mempool to be confirmed before continuing.
     * @async
     * @return {Boolean} Returns `true` once it is safe to continue sending transactions
     */

  }, {
    key: "checkAncestorCount",
    value: function () {
      var _checkAncestorCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var startAncestorCount, startAncestorSize, firstLoop, hadMaxAncestors, reachedAncestorLimitTimestamp, hasMaxAncestors, numberConfirmed, i;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Store our starting count
                startAncestorCount = this.currentAncestorCount;
                startAncestorSize = this.currentAncestorSize; // Variables to track loop state

                firstLoop = true;
                hadMaxAncestors = false;

              case 4:
                if (!(this.currentAncestorCount >= MAX_MEMPOOL_ANCESTORS || this.currentAncestorSize >= MAX_MEMPOOL_ANCESTOR_SIZE)) {
                  _context3.next = 20;
                  break;
                }

                if (firstLoop) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 8;
                return new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    resolve();
                  }, UPDATE_ANCESTOR_STATUS);
                });

              case 8:
                _context3.next = 10;
                return this.updateAncestorStatus();

              case 10:
                // Check if we currently have the maximum number of ancestors
                hasMaxAncestors = this.currentAncestorCount >= MAX_MEMPOOL_ANCESTORS || this.currentAncestorSize >= MAX_MEMPOOL_ANCESTOR_SIZE; // Only log ancestor count if it is the first loop, and we still have too many ancestors

                if (hasMaxAncestors && firstLoop) {
                  console.log("[RPC Wallet] Maximum Unconfirmed Transaction count reached, pausing sending of transactions until some of the current transactions get confirmed | Ancestor Count: ".concat(this.currentAncestorCount, " - Ancestor Size: ").concat((this.currentAncestorSize / ONE_MB).toFixed(2), "MB"));
                  hadMaxAncestors = true;
                  reachedAncestorLimitTimestamp = Date.now();
                } // After it has been REPAIR_ANCESTORS_AFTER amount of time since the max ancestor limit was reached, enable repair mode


                if (!(hasMaxAncestors && Date.now() - REPAIR_ANCESTORS_AFTER > reachedAncestorLimitTimestamp)) {
                  _context3.next = 17;
                  break;
                }

                // Announce that we are going to attempt the repair
                console.log("[RPC Wallet] [WARNING] Unconfirmed Transaction count has not decreased in ".concat(REPAIR_ANCESTORS_AFTER / ONE_MINUTE, " minutes, rebroadcasting transactions in an attempt to repair the utxo chain!")); // Attempt the actual repair

                _context3.next = 16;
                return this.rebroadcastTransactions();

              case 16:
                // Reset the timestamp so that we wait for REPAIR_ANCESTORS_AFTER seconds/minutes
                reachedAncestorLimitTimestamp = Date.now();

              case 17:
                firstLoop = false;
                _context3.next = 4;
                break;

              case 20:
                // Count the number of confirmed
                numberConfirmed = startAncestorCount - this.currentAncestorCount; // Remove the transactions that just got confirmed

                for (i = 0; i < numberConfirmed; i++) {
                  this.unconfirmedTransactions.shift();
                } // Check to see how many transactions got confirmed


                if (!(startAncestorCount >= MAX_MEMPOOL_ANCESTORS || startAncestorSize >= MAX_MEMPOOL_ANCESTOR_SIZE)) {
                  _context3.next = 28;
                  break;
                }

                console.log("[RPC Wallet] ".concat(numberConfirmed, " Transactions Confirmed! (").concat(((startAncestorSize - this.currentAncestorSize) / ONE_MB).toFixed(2), " MB)")); // If there are less confirmed than REPAIR_MIN_TX, then rebroadcast the transactions

                if (!(numberConfirmed < REPAIR_MIN_TX)) {
                  _context3.next = 28;
                  break;
                }

                console.log("[RPC Wallet] Detected low number of transactions confirmed, re-announcing transactions to make sure miners saw them.");
                _context3.next = 28;
                return this.rebroadcastTransactions();

              case 28:
                // If we had started with maximum ancestors, then log the status
                if (hadMaxAncestors) {
                  console.log("[RPC Wallet] Unconfirmed count has decreased, resuming sending transactions! | Ancestor Count: ".concat(this.currentAncestorCount, " - Ancestor Size: ").concat((this.currentAncestorSize / ONE_MB).toFixed(2), "MB"));
                } // If we enabled repair mode, then


                this.repairMode = false; // There are fewer ancestors than the maximum, so we can send the next transaction!

                return _context3.abrupt("return", true);

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkAncestorCount() {
        return _checkAncestorCount.apply(this, arguments);
      }

      return checkAncestorCount;
    }()
    /**
     * Rebroadcast out all transactions on our local mempool
     */

  }, {
    key: "rebroadcastTransactions",
    value: function () {
      var _rebroadcastTransactions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var numAnnounced, _iterator, _step, txHex, _iterator2, _step2, peer;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Announce that we are starting
                console.log("[RPC Wallet] Announcing ".concat(this.unconfirmedTransactions.length, " transactions to Peers...")); // Connect to Peers to use for the rebroadcast

                _context4.next = 3;
                return this.connectToPeers();

              case 3:
                // Announce all of our local unconfirmed transactions
                numAnnounced = 0;
                _iterator = _createForOfIteratorHelper(this.unconfirmedTransactions);
                _context4.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context4.next = 31;
                  break;
                }

                txHex = _step.value;
                // Loop through all peers and announce TX individually to each (if we have connected to them\
                _iterator2 = _createForOfIteratorHelper(this.peers);
                _context4.prev = 10;

                _iterator2.s();

              case 12:
                if ((_step2 = _iterator2.n()).done) {
                  _context4.next = 19;
                  break;
                }

                peer = _step2.value;

                if (!peer.connected) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 17;
                return peer.announceTX(txHex);

              case 17:
                _context4.next = 12;
                break;

              case 19:
                _context4.next = 24;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](10);

                _iterator2.e(_context4.t0);

              case 24:
                _context4.prev = 24;

                _iterator2.f();

                return _context4.finish(24);

              case 27:
                // Log every 50 transactions
                numAnnounced++;

                if (numAnnounced % 50 === 0) {
                  console.log("[RPC Wallet] Announced ".concat(numAnnounced, "/").concat(this.unconfirmedTransactions.length, " transactions so far..."));
                }

              case 29:
                _context4.next = 7;
                break;

              case 31:
                _context4.next = 36;
                break;

              case 33:
                _context4.prev = 33;
                _context4.t1 = _context4["catch"](5);

                _iterator.e(_context4.t1);

              case 36:
                _context4.prev = 36;

                _iterator.f();

                return _context4.finish(36);

              case 39:
                console.log("[RPC Wallet] Announced ".concat(numAnnounced, " transactions!")); // Wait for REBROADCAST_LENGTH in order to give some time for transactions to be requested, and sent out.

                _context4.next = 42;
                return new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    resolve();
                  }, REBROADCAST_LENGTH);
                });

              case 42:
                // Destroy the peers we connected too
                this.destroyPeers();

              case 43:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 33, 36, 39], [10, 21, 24, 27]]);
      }));

      function rebroadcastTransactions() {
        return _rebroadcastTransactions.apply(this, arguments);
      }

      return rebroadcastTransactions;
    }()
    /**
     * Initialize the RPC Wallet. This imports the Private Key, and then checks for unconfirmed transactions in the mempool.
     * @async
     * @return {Boolean} Returns true on Success
     */

  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var importPrivKey, utxos, nextTXID, txHex, txMemInfo;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.importPrivateKey) {
                  _context5.next = 8;
                  break;
                }

                console.log("[RPC Wallet] Importing the Private Key to the RPC Wallet, this may take a long time..."); // First, we import the Private Key to make sure it exists when we attempt to send transactions.

                _context5.next = 4;
                return this.rpcRequest('importprivkey', [this.wif, 'default', true]);

              case 4:
                importPrivKey = _context5.sent;
                console.log("[RPC Wallet] Private Key Import to the RPC Wallet Complete!"); // Check for an error importing the private key. If there is no error, the private key import was successful.
                // No error and no result signify that the Private Key was already imported previously to the wallet.

                if (!(importPrivKey.error && importPrivKey.error !== null && importPrivKey.error.message !== 'Key already exists.')) {
                  _context5.next = 8;
                  break;
                }

                throw new Error('Error Importing Private Key to RPC Wallet: ' + JSON.stringify(importPrivKey.error));

              case 8:
                _context5.next = 10;
                return this.updateAncestorStatus();

              case 10:
                if (!(this.currentAncestorCount === 0)) {
                  _context5.next = 12;
                  break;
                }

                return _context5.abrupt("return", true);

              case 12:
                console.log("[RPC Wallet] Loading ".concat(this.currentAncestorCount, " transactions into local mempool, please wait... (this may take a little while)"));
                /* Update the tx chain */
                // First, we need to get a list of unconfirmed transactions, to do this, we need the most recent utxo.

                _context5.next = 15;
                return this.getUTXOs();

              case 15:
                utxos = _context5.sent;
                // Then, while we have ancestors, lookup the transaction hex, and add it to the start of the unconfirmed transaction chain
                nextTXID = utxos[0].txid;

              case 17:
                if (!nextTXID) {
                  _context5.next = 33;
                  break;
                }

                _context5.next = 20;
                return this.rpcRequest('getrawtransaction', [nextTXID]);

              case 20:
                txHex = _context5.sent;

                if (!(txHex.error && txHex.error !== null)) {
                  _context5.next = 23;
                  break;
                }

                throw new Error('Error gathering raw transaction for (' + nextTXID + '): ' + JSON.stringify(txHex.error));

              case 23:
                // Add the raw tx hex to the start of the unconfirmed transactions list
                this.unconfirmedTransactions.unshift(txHex.result); // Then lookup to see if it is in the mempool

                _context5.next = 26;
                return this.rpcRequest('getmempoolentry', [nextTXID]);

              case 26:
                txMemInfo = _context5.sent;

                if (!(txMemInfo.error && txMemInfo.error !== null)) {
                  _context5.next = 29;
                  break;
                }

                throw new Error('Error gathering mempool entry for (' + nextTXID + '): ' + JSON.stringify(txMemInfo.error));

              case 29:
                // See if there are any parent txs that our tx "depends" on and need to be confirmed
                if (txMemInfo.result.depends.length > 0) {
                  // Store the parent tx to search through next
                  nextTXID = txMemInfo.result.depends[0];
                } else {
                  // If there are no transactions that ours depend on, then we can exit the loop
                  nextTXID = undefined;
                } // Log every 50 added


                if (this.unconfirmedTransactions.length % 50 === 0) {
                  console.log("[RPC Wallet] Loaded ".concat(this.unconfirmedTransactions.length, "/").concat(this.currentAncestorCount, " transactions into local mempool so far..."));
                }

                _context5.next = 17;
                break;

              case 33:
                console.log("[RPC Wallet] Loaded ".concat(this.unconfirmedTransactions.length, " transactions into local mempool!")); // Return true, signifying that the initialization was successful

                return _context5.abrupt("return", true);

              case 35:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
    /**
     * Create fcoin "Peers" for all peers that the rpc full node as access to.
     * @async
     */

  }, {
    key: "connectToPeers",
    value: function () {
      var _connectToPeers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var getPeerInfo, _iterator3, _step3, peerInfo, peerHost, peer, connectedPeers, _iterator4, _step4, _peer;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // Initialize/wipe peers
                this.peers = []; // Request peers to connect to from the RPC node we have access to

                _context6.next = 3;
                return this.rpcRequest('getpeerinfo', []);

              case 3:
                getPeerInfo = _context6.sent;

                if (!getPeerInfo.error) {
                  _context6.next = 6;
                  break;
                }

                throw new Error(getPeerInfo.error);

              case 6:
                console.log("[RPC Wallet] Connecting to ".concat(getPeerInfo.result.length, " Peers...")); // For each of those peers, open up a connection

                _iterator3 = _createForOfIteratorHelper(getPeerInfo.result);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    peerInfo = _step3.value;
                    // Create an fcoin peer
                    peerHost = peerInfo.addr; // Always rewrite the port.

                    if (peerHost.includes(':')) {
                      peerHost = peerHost.substring(0, peerHost.indexOf(':'));
                    } // Set to test or mainnet ourselves.


                    if (this.options.network && (this.options.network === 'mainnet' || this.options.network === 'livenet')) {
                      peerHost = peerHost + ':7312';
                    } else {
                      peerHost = peerHost + ':17312';
                    }

                    console.log("peer host ".concat(peerHost));
                    peer = new _Peer.default({
                      ip: peerHost,
                      network: this.options.network
                    }); // Start the connection attempt

                    peer.connect(); // Add it to our peerrs array

                    this.peers.push(peer);
                  } // Wait for PEER_CONNECT_LENGTH in order to allow peers to initialize

                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                _context6.next = 11;
                return new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    resolve();
                  }, PEER_CONNECT_LENGTH);
                });

              case 11:
                // Count how many peers we have successfully connected to
                connectedPeers = 0;
                _iterator4 = _createForOfIteratorHelper(this.peers);

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    _peer = _step4.value;

                    if (_peer.connected) {
                      connectedPeers++;
                    }
                  } // Log the connected count

                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                console.log("[RPC Wallet] Connected to ".concat(connectedPeers, " Peers!"));

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function connectToPeers() {
        return _connectToPeers.apply(this, arguments);
      }

      return connectToPeers;
    }()
    /**
     * Destroy peers created in rebroadcastTransactions
     */

  }, {
    key: "destroyPeers",
    value: function destroyPeers() {
      // Destroy each `fcoin` peer
      var _iterator5 = _createForOfIteratorHelper(this.peers),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var peer = _step5.value;
          peer.peer.destroy();
        } // Wipe out the array

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.peers = [];
    }
    /**
     * Sign a message using the internal private key
     * @async
     * @param  {String} message - The message you wish to have signed
     * @return {String}  Returns the base64 version of the Signature
     */

  }, {
    key: "signMessage",
    value: function () {
      var _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(message) {
        var myECPair, privateKeyBuffer, compressed, signatureBuffer, signature;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // Create the ECPair to sign with (this is the Private Key basically)
                myECPair = _bitcoinjsLib.ECPair.fromWIF(this.wif, this.coin.network);
                privateKeyBuffer = myECPair.privateKey; // Check if we are a compress privKey

                compressed = myECPair.compressed || true; // Create the actual signature

                _context7.prev = 3;
                signatureBuffer = (0, _bitcoinjsMessage.sign)(message, privateKeyBuffer, compressed, myECPair.network.messagePrefix);
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](3);
                throw new Error(_context7.t0);

              case 10:
                // Convert the signature to a base64 string
                signature = signatureBuffer.toString('base64'); // Return the base64 signature

                return _context7.abrupt("return", signature);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 7]]);
      }));

      function signMessage(_x3) {
        return _signMessage.apply(this, arguments);
      }

      return signMessage;
    }()
    /**
     * Get the latest unspent transaction outputs
     * @async
     * @return {Array.<Object>} Returns an Array of UTXO's
     */

  }, {
    key: "getUTXOs",
    value: function () {
      var _getUTXOs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var MIN_CONFIRMATIONS, MAX_CONFIRMATIONS, utxoRes, utxos, filtered;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.previousTXOutput && this.previousTXOutput.amount > MIN_UTXO_AMOUNT)) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", [this.previousTXOutput]);

              case 2:
                // On the first run, log that we are requesting the transaction output.
                if (!this.initialUTXOLog) {
                  console.log('[RPC Wallet] Grabbing initial transaction output to use, this may take a few seconds...');
                  this.initialUTXOLog = true;
                } // Request the list of unspent transactions


                MIN_CONFIRMATIONS = 0;
                MAX_CONFIRMATIONS = 9999999;
                _context8.next = 7;
                return this.rpcRequest('listunspent', [MIN_CONFIRMATIONS, MAX_CONFIRMATIONS, [this.publicAddress]]);

              case 7:
                utxoRes = _context8.sent;

                if (!(utxoRes.error && utxoRes.error !== null)) {
                  _context8.next = 10;
                  break;
                }

                throw new Error('Unable to get unspent transactions for: ' + this.publicAddress + '\n' + JSON.stringify(utxoRes.error));

              case 10:
                // Pull out the utxos array
                utxos = utxoRes.result; // Filter out transactions that don't meet our minimum UTXO value

                filtered = utxos.filter(function (utxo) {
                  if (utxo.amount >= MIN_UTXO_AMOUNT) {
                    return true;
                  }

                  return false;
                }); // Check if we have no transaction outputs available to spend from, and throw an error if so

                if (!(filtered.length === 0)) {
                  _context8.next = 14;
                  break;
                }

                throw new Error('No previous unspent output available! Please send some FLO to ' + this.publicAddress + ' and then try again!');

              case 14:
                // Sort by confirmations descending (highest conf first)
                filtered.sort(function (a, b) {
                  return b.confirmations - a.confirmations;
                }); // Return the filtered and sorted utxos

                return _context8.abrupt("return", filtered);

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getUTXOs() {
        return _getUTXOs.apply(this, arguments);
      }

      return getUTXOs;
    }()
    /**
     * Create and broadcast a transaction containing the requested data as floData
     * @async
     * @param  {String} floData - The data you wish to be placed into the `floData` of the transaction.
     * @return {String} Returns the TXID of the transaction if sent successfully
     */

  }, {
    key: "sendDataToChain",
    value: function () {
      var _sendDataToChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(floData) {
        var utxos, input, myTxFee, output, txid;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getUTXOs();

              case 2:
                utxos = _context9.sent;
                // Select the first input (since we have already sorted and filtered)
                input = utxos[0]; // Calculate the minimum Transaction fee for our transaction by counting the size of the inputs, outputs, and floData

                myTxFee = (this.options.txFeePerByte || TX_FEE_PER_BYTE) * (TX_AVG_BYTE_SIZE + (0, _util.varIntBuffer)(floData.length).toString('hex').length + Buffer.from(floData).length); // Create an output to send the funds to

                output = {};
                output[this.publicAddress] = parseFloat((input.amount - myTxFee).toFixed(8)); // Send the transaction

                _context9.next = 9;
                return this.sendTX([input], output, floData);

              case 9:
                txid = _context9.sent;
                return _context9.abrupt("return", txid);

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function sendDataToChain(_x4) {
        return _sendDataToChain.apply(this, arguments);
      }

      return sendDataToChain;
    }()
    /**
     * Create and sign a transaction using bitcoinjs-lib and js-oip libraries
     * @param  {Object} input   [description]
     * @param  {Object} outputs [description]
     * @param  {String} floData [description]
     * @return {String} Returns the built hex string
     */

  }, {
    key: "createAndSignTransaction",
    value: function createAndSignTransaction(input, outputs, floData) {
      // Create a Bitcoinjs-lib transaction builder, and pass it the FLO network params
      var txb = new _FLOTransactionBuilder.default(this.coin.network); // Add our single input

      txb.addInput(input.txid, input.vout); // Add our output

      txb.addOutput(this.publicAddress, parseInt(outputs[this.publicAddress] * SAT_PER_FLO)); // Add our floData

      txb.setFloData(floData); // Sign our transaction using the local `flosigner` at `src/config/networks/flo/flosigner.js`

      txb.sign(0, _bitcoinjsLib.ECPair.fromWIF(this.wif, this.coin.network)); // Build the hex

      var builtHex;

      try {
        builtHex = txb.build().toHex();
      } catch (err) {
        throw new Error("Unable to build Transaction Hex!: ".concat(err));
      } // Return the completed hex as a string


      return builtHex;
    }
    /**
     * Send a Transaction using the requested inputs, outputs, and floData
     * @async
     * @param  {Array.<Object>} inputs  - An array of utxo inputs to use to fund the transaction
     * @param  {Object} outputs - An Object that contains addresses to output to as the key, and the amount to send as the value (i.e. `{ 'mypublicaddresshere': 1 }`)
     * @param  {String} floData - The `floData` you wish to include in the transaction
     * @return {String} Returns the txid of the transaction if sent successfully
     */

  }, {
    key: "sendTX",
    value: function () {
      var _sendTX = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(inputs, outputs, floData) {
        var signedTXHex, broadcastTX;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(typeof floData !== 'string')) {
                  _context10.next = 2;
                  break;
                }

                throw new Error("Data must be of type string. Got: ".concat(typeof floData));

              case 2:
                if (!(floData.length > _FLOTransaction.FLODATA_MAX_LEN)) {
                  _context10.next = 4;
                  break;
                }

                throw new Error("Error: 'floData' length exceeds ".concat(_FLOTransaction.FLODATA_MAX_LEN, " characters. Please send a smaller data package."));

              case 4:
                _context10.next = 6;
                return this.checkAncestorCount();

              case 6:
                // Create and sign the transaction hex
                signedTXHex = this.createAndSignTransaction(inputs[0], outputs, floData); // Broadcast the transaction hex we created to the network

                _context10.next = 9;
                return this.rpcRequest('sendrawtransaction', [signedTXHex]);

              case 9:
                broadcastTX = _context10.sent;

                if (!(broadcastTX.error && broadcastTX.error !== null)) {
                  _context10.next = 12;
                  break;
                }

                throw new Error('Error broadcasting tx: ' + signedTXHex + '\n' + JSON.stringify(broadcastTX.error));

              case 12:
                // Add the tx we just sent to the Ancestor count
                this.addAncestor(signedTXHex); // Add our tx hex to the unconfirmed transactions array

                this.unconfirmedTransactions.push(signedTXHex); // Set the new tx to be used as the next output.

                this.previousTXOutput = {
                  txid: broadcastTX.result,
                  amount: outputs[this.publicAddress],
                  vout: 0
                }; // Return the TXID of the transaction

                return _context10.abrupt("return", broadcastTX.result);

              case 16:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function sendTX(_x5, _x6, _x7) {
        return _sendTX.apply(this, arguments);
      }

      return sendTX;
    }()
  }]);

  return RPCWallet;
}();

var _default = RPCWallet;
exports.default = _default;